import { Typography } from '@components'
import { useTranslation } from 'react-i18next'
import type { SearchConfigStyles } from './types'
import { SearchProductList } from './SearchProductList'
import type { SearchResult } from '@haus-storefront-react/shared-types'
import styles from './Search.module.scss'

interface SearchPrefilledResultsProps {
  items: SearchResult[]
  isLoading: boolean
  error: Error | null
  configStyles?: SearchConfigStyles
}

export function SearchPrefilledResults({
  items,
  isLoading,
  error,
  configStyles,
}: SearchPrefilledResultsProps) {
  const { t } = useTranslation()
  if (isLoading) {
    return (
      <div className={styles.loading} role="status" aria-live="polite" aria-busy="true">
        <Typography variant="body">{t('search.loading')}</Typography>
      </div>
    )
  }
  if (error) {
    return (
      <div className={styles.error} role="alert">
        <Typography variant="body">{t('search.error')}</Typography>
      </div>
    )
  }

  if (items.length === 0 && !isLoading) {
    return (
      <div className={styles.empty} role="status">
        <Typography variant="body">{t('search.noResults')}</Typography>
      </div>
    )
  }

  return (
    <div className={styles.resultsWrapper}>
      <Typography variant="body" as="h2" className={styles.popularSearchesHeading}>
        {t('searchField.popularProducts')}
      </Typography>
      <SearchProductList configStyles={configStyles} items={items} />
    </div>
  )
}
